export default {
    company_agency: "Tienda",
    document: "Número de identificación",
    extensions: "Formato",
    project_name: "Elanco School",
    user: "Correo electrónico",
    welcome_to: "Bienvenido a",
}